<span class="help-toggler" (click)="helpModal.openModal(modalName)">{{ triggerLabel }}</span>
<ycn-help-modal #helpModal></ycn-help-modal>
